// extracted by mini-css-extract-plugin
module.exports = {"Icon":"IconsSelect_Icon__Z3dV3","IconsWrap":"IconsSelect_IconsWrap__22H9p","Add":"IconsSelect_Add__3LWsR","InputFile":"IconsSelect_InputFile__3UaGL"};